'use client';

import React from 'react';
import Link from 'next/link';
import { ArrowLeft, Home } from 'lucide-react';

/**
 * Страница «не найдено».
 *
 * Классы вроде `text-onBackground` и `bg-primary` достались от шаблона и ни
 * к чему не привязаны — в конфиге Tailwind таких цветов нет, так что текст
 * красился ничем. Переведена на палитру проекта и на русский: остальной
 * интерфейс русский, а английская страница выглядит как чужая вкладка.
 */
export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-canvas p-4">
      <div className="text-center max-w-md">
        <h1 className="text-8xl font-bold text-slate-200">404</h1>

        <h2 className="text-xl font-semibold text-slate-800 mt-4">Страница не найдена</h2>
        <p className="text-sm text-slate-500 mt-2">
          Такого адреса нет. Возможно, ссылка устарела или в ней опечатка.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
          <button onClick={() => window.history.back()} className="btn-secondary justify-center">
            <ArrowLeft size={16} />
            Назад
          </button>

          <Link href="/dashboard" className="btn-primary justify-center">
            <Home size={16} />К дашборду
          </Link>
        </div>
      </div>
    </div>
  );
}
